import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { FeaturesEnums } from 'src/shared/enums';
import { ComponentWithFeatures } from 'src/shared/hocs';
import { useFeatures } from 'src/shared/hooks';

import { AbsencesCard } from './AbsenceCard';
import { AccrualBalancesCard } from './AccrualBalancesCard';
import { DashboardHeader } from './DashboardHeader';
import { EssBanner } from './EssBanner';
import { PunchCard } from './PunchCard';
import { QuickEntryCard } from './QuickEntryCard';
import { TimecardCard } from './TimecardCard';
import { TimesheetCard } from './TimesheetCard';
import { WeeklyCalendarEvents } from './WeeklyCalendarEvents';
import './HomePage.styles.scss';

export const HomePage: FC = () => {
  const hasWebPunchFeature = useFeatures(FeaturesEnums.WebPunchFeature);

  return (
    <div id="page-wrapper">
      <DashboardHeader />
      <EssBanner />
      <Stack direction="row" gap={2} flexWrap="wrap" mt={2}>
        <Stack flex={1} direction="column" gap={2}>
          {!hasWebPunchFeature && (
            <ComponentWithFeatures features={FeaturesEnums.Timesheet}>
              <Box minHeight={320}>
                <QuickEntryCard />
              </Box>
              <Box minHeight={320}>
                <TimesheetCard />
              </Box>
            </ComponentWithFeatures>
          )}
          <ComponentWithFeatures features={FeaturesEnums.WebPunchFeature}>
            <Box minHeight={320}>
              <PunchCard />
            </Box>
          </ComponentWithFeatures>
          <ComponentWithFeatures features={FeaturesEnums.ESSTimecard}>
            <Box minHeight={320}>
              <TimecardCard />
            </Box>
          </ComponentWithFeatures>
        </Stack>
        <Stack flex={1} direction="column" gap={2}>
          <ComponentWithFeatures features={FeaturesEnums.Schedule_Employee_Absences}>
            <Box minHeight={320}>
              <AbsencesCard />
            </Box>
          </ComponentWithFeatures>
          <ComponentWithFeatures features={FeaturesEnums.AccrualsFunction}>
            <Box minHeight={320}>
              <AccrualBalancesCard />
            </Box>
          </ComponentWithFeatures>
        </Stack>
      </Stack>
      <ComponentWithFeatures features={FeaturesEnums.EmployeeCalendar}>
        <div className="pt-3 w-100">
          <WeeklyCalendarEvents />
        </div>
      </ComponentWithFeatures>
    </div>
  );
};
